import type { FlatFormInput } from "web_myplann/Portfolio/Forms/FlatForm/flatFormSchema";

export const FLAT_FORM_DEFAULT_VALUES: FlatFormInput = {
	location: "",
	locationMunicipality: "",
	locationZipCode: "",
	usableArea: null,
	floorArea: null,
	disposition: null,
	buildingMaterial: null,
	interiorValue: null,
	purchaseDate: null,
	description: "",
	terrace: false,
	loggia: false,
	balcony: false,
	garage: false,
	cellar: false,
	elevator: false,
	barrierFree: false,
	swimmingPool: false,
	forInvestments: false,
};
